import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "../../Common/utils/auth";
//import routes
import securityRoutes from "./routes/SecurityRoutes";
import addressProgramRoutes from "./routes/AddressProgramRoutes";
import addressProgramArchivedRoutes from "./routes/AddressProgramArchivedRoutes";
import workflowRoutes from "./routes/WorkflowRoutes";
import systemSettingRoutes from "./routes/SystemSettingRoutes";
import securityAdminRoutes from "./routes/SecurityAdminRoutes";
import schedulerRoutes from "./routes/SchedulerRoutes";
import notificationRoutes from "./routes/NotificationRoutes";
import baseTypeRoutes from "./routes/BaseTypeRoutes";
import competenceRoutes from "./routes/CompetenceRoutes";

const routes = [
  securityRoutes,
  addressProgramRoutes,
  addressProgramArchivedRoutes,
  workflowRoutes,
  systemSettingRoutes,
  securityAdminRoutes,
  schedulerRoutes,
  notificationRoutes,
  baseTypeRoutes,
  competenceRoutes
].flat();

const comingSoonRoutes = [];

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({
    y: 0,
  }),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  if (to.path !== "/security/login" && !hasToken) {
    if (["locallogin", "login", "auth"].indexOf(to.name) == -1) {
      window.location.href = `/security/login?redirect=${to.path}`;
    } else {
      next();
    }
  } else if (comingSoonRoutes.includes(to.path)) {
    next(`/information/coming-soon`);
  } else if (to.meta.menuitem && !to.query.menuitem) {
    next({
      path: to.path,
      query: { ...to.query, menuitem: btoa(to.meta.menuitem) },
    });
  } else {
    next();
  }
});

export default router;
